export default __webpack_public_path__ + "static/media/CNo.57-5.af6ed395.jpg";